<template>
  <div class="footer">
    <!-- <p class="login-title">登录即可参与活动，领取红包！</p> -->
    <p class="healthy-title" v-if="false">
      积极健康的游戏心态是健康游戏的开端，请您合理控制游戏时间，
      避免沉溺游戏影响生活，注意自我保护，防范网络陷阱。
    </p>
    <p class="ftCont" v-if="false">
      <span>关于</span>
      <span class="fg-Line">|</span>
      <span>用户隐私</span>
      <span class="fg-Line">|</span>
      <span>玩家客服</span>
      <span class="fg-Line">|</span>
      <span>家长监护工程</span>
    </p>
    <p class="company-name">广州迪麦信息科技有限公司</p>
    <p class="company-address">广州市天河区棠安路146号2002房</p>
    <p class="yuewen">粤网文(2017) 8953-2246号粤ICP备17024417号</p>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  created() {},
  methods: {}
};
</script>
<style lang='less' scoped>
.footer {
  width: 100%;
  padding-top: 0.2rem;
  margin-bottom: 80px;
  .login-title {
    font-size: 0.333333rem /* 25/75 */;
    color: #666;
    text-align: center;
    margin-top: 0.333333rem /* 25/75 */;
  }
  .healthy-title {
    padding: 0 1rem /* 30/75 */;
    font-size: 0.333333rem /* 25/75 */;
    color: #ff9d11;
    text-align: center;
    margin-top: 0.333333rem /* 25/75 */;
  }
  .ftCont {
    text-align: center;
    margin-top: 0.266667rem /* 20/75 */;
    font-size: 0.466667rem /* 35/75 */;
    .fg-Line {
      padding-left: 0.266667rem /* 20/75 */;
      padding-right: 0.266667rem /* 20/75 */;
    }
  }
  .company-name,
  .company-address,
  .yuewen {
    color: #666666;
    font-size: 0.333333rem /* 25/75 */;
    text-align: center;
  }
  .company-name {
    margin-top: 0.266667rem /* 20/75 */;
  }
}
</style>